export default [
  {
    name: 'Training Overview',
    path: '/training',
    component: () => import(/* webpackChunkName: "training" */ '@/views/training/TrainingView.vue')
  },
  {
    name: 'Training Extension',
    path: '/training/extension',
    component: () => import(/* webpackChunkName: "training" */ '@/views/training/TrainingExtensionView.vue')
  },
  {
    name: 'Training Service',
    path: '/training/:service',
    component: () => import(/* webpackChunkName: "training" */ '@/views/training/TrainingServiceView.vue')
  },

  // Backward-compat redirects
  {
    path: '/onboarding',
    redirect: '/training'
  },
  {
    path: '/onboarding/training',
    redirect: '/training'
  },
  {
    path: '/onboarding/training/extension',
    redirect: '/training/extension'
  },
  {
    path: '/onboarding/training/:service',
    redirect: to => `/training/${to.params.service}`
  },
  {
    path: '/onboarding/account',
    redirect: '/training'
  },
  {
    path: '/onboarding/account/:path(.*)',
    redirect: '/training'
  },
  {
    path: '/onboarding/complete',
    redirect: '/training'
  }
]
